export interface MenuDB {
    name: string;
    status: string;
    created_on: string;
}

export const MENUDB: MenuDB[] = [
    {
        "name": "Product Menu",
        "status": "font-success",
        "created_on": "2018-04-18T00:00:00",
    },
    {
        "name": "Category Menu",
        "status": "font-warning",
        "created_on": "2018-04-18T00:00:00",
    },
    {
        "name": "Subcategory Menu",
        "status": "font-success",
        "created_on": "2018-04-18T00:00:00",
    },
    {
        "name": "Sales Menu",
        "status": "font-danger",
        "created_on": "2018-04-18T00:00:00",
    },
    {
        "name": "Vendor Menu",
        "status": "font-success",
        "created_on": "2018-04-18T00:00:00",
    },
    {
        "name": "Category Menu",
        "status": "font-warning",
        "created_on": "2018-04-18T00:00:00",
    },
]
